import styled from 'styled-components';

const alphaColor = (color: string, alpha: number) => {
  const newColor = color.replace('1)', `${alpha})`);
  return newColor;
};

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const MessageFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  gap: 12px;
`;

export const Accordion = styled.form<{ show: boolean }>`
  display: grid;
  grid-template-rows: ${({ show }) => (show ? 1 : 0)}fr;
  transition: grid-template-rows 2s ease;
`;

export const AccordionContent = styled.div`
  overflow: hidden;
`;

export const HelpText = styled.div`
  font-size: 0.75rem;
  margin-top: 0.5rem;
`;

export const BottomField = styled.div`
  width: 100%;
  margin-top: 100px;
  padding: 0;
`;

export const Label = styled.label`
  display: block;
  ${({ theme: { font } }) => font.t3};
`;

export const PasswordInputContainer = styled.div`
  position: relative;
`;

export const HideShowButtonContainer = styled.div`
  position: absolute;
  right: 6px;
  top: 6px;
  display: flex;
`;

export const HideShowButton = styled.div`
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  cursor: pointer;
  overflow: hidden;
  outline: none;
`;

export const LinkButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const LoginLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Heading = styled.div<{ $isSuccess: boolean }>`
  ${({ theme: { font } }) => font.t1};
  display: flex;
  justify-content: ${({ $isSuccess }) => ($isSuccess ? 'center' : 'left')};
`;

export const PasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Card = styled.div<{ $themeColor: string; $secondaryColor: string }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  gap: 4px;
  color: ${({ $themeColor }) => $themeColor};
  border-radius: 4px;
  padding: 12px 12px 0px 12px;
  background-color: #f9f9f9;
  transition: all 0.15s ease;
  border: 1px solid #e5e5e5;
  &:hover {
    background-color: ${({ $secondaryColor }) => alphaColor($secondaryColor, 0.075)};
    color: ${({ $secondaryColor }) => $secondaryColor};
    cursor: pointer;
    border: 1px solid ${({ $secondaryColor }) => alphaColor($secondaryColor, 0.3)};
  }
`;

export const CardButton = styled.div`
  border-radius: 4px;
  font-size: 20px;
  font-weight: 500;
  font-family: 'Roboto', sans-serif;
`;

export const CardDescription = styled.p`
  font-size: 13px;
  color: #555;
`;
